import React from 'react';
import { QuoteIcon } from 'lucide-react';
const testimonials = [{
  quote: 'We have been working with KEENA for years now. Any time there is a problem or situation that needs attention, they are immediately on it! We are extremely happy and grateful for the support they provide our company!',
  author: 'Eric Gaudreau',
  title: 'Vice President, Better Than New Painting Inc.'
}, {
  quote: 'When questioned about what we do for Payroll and Workers Comp, I tell people to go right to KEENA. Probably one of the best decisions we ever made as an employer.',
  author: 'Jeff Fehl',
  title: 'Owner, Adirondack Greenscapes'
}, {
  quote: 'As a small business owner, I\'ve always felt it is important to know which experts to hire for the aspects of the job that you don\'t know as well. Keena has always been my "expert-of-choice" for my payroll needs, and I recommend them highly!',
  author: 'Connie Brooks',
  title: 'Owner, Battenkill Books, LLC'
}, {
  quote: 'We truly appreciate the care and attention KEENA has given us. The reminders and proactive support have been extremely helpful, and the transition has been much smoother than we anticipated thanks to how responsive and on top of things the team has been.',
  author: 'Flatley Read',
  title: 'Greenwich, NY'
}];
export function TestimonialsSection() {
  return <section className="pt-6 pb-16 bg-gray-50" data-id="element-137">
      {/* CTA - tighter to stats above */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-20" data-id="element-138">
        <div className="text-center" data-id="element-139">
          <a href="#form-bottom" className="inline-block bg-orange hover:bg-orange-hover text-white font-semibold py-4 px-8 rounded-lg transition-colors duration-200 shadow-md text-lg" data-id="element-140">
            Get Started
          </a>
        </div>
      </div>

      {/* Horizontal scroll container */}
      <div className="relative" data-id="element-141">
        {/* Fade edges */}
        <div className="absolute left-0 top-0 bottom-0 w-16 bg-gradient-to-r from-gray-50 to-transparent z-10 pointer-events-none" data-id="element-142"></div>
        <div className="absolute right-0 top-0 bottom-0 w-16 bg-gradient-to-l from-gray-50 to-transparent z-10 pointer-events-none" data-id="element-143"></div>

        <div className="overflow-x-auto scrollbar-hide pb-4 px-8 lg:px-16" data-id="element-144">
          <div className="flex gap-8 w-max" data-id="element-145">
            {testimonials.map((testimonial, index) => <div key={index} className="bg-white rounded-2xl p-10 shadow-sm border border-gray-100 flex flex-col justify-between w-[500px] min-w-[420px] flex-shrink-0 relative" data-id="element-146">
                {/* Quote icon */}
                <div className="absolute top-8 right-8" data-id="element-147">
                  <QuoteIcon className="w-12 h-12 text-orange/20" data-id="element-148" />
                </div>

                <p className="text-gray-700 text-lg italic leading-relaxed mb-8 pr-10" data-id="element-149">
                  "{testimonial.quote}"
                </p>

                <div data-id="element-150">
                  <div className="font-bold text-navy text-lg" data-id="element-151">
                    {testimonial.author}
                  </div>
                  <div className="text-sm text-orange font-medium" data-id="element-152">
                    {testimonial.title}
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}